module.exports = __webpack_public_path__ + "static/media/20170806_19day_0902AT.adf74218.jpg";